import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'fomantic-ui-css/semantic.min.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import { createStore } from 'redux';
import allReducers from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';

const myStore = createStore(allReducers, composeWithDevTools());

ReactDOM.render(
    <React.StrictMode>
        <Provider store={myStore}>
            <App />
            <ReduxToastr
                timeOut={2500}
                transitionIn='fadeIn'
                transitionOut='fadeOut'
                preventDuplicates
                position='top-left'
                progressBar
            />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
